// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD9h50Ufj_Kk3c69WJGfSqao2tvhcxQ-6A",
  authDomain: "steam-reviews-47666.firebaseapp.com",
  projectId: "steam-reviews-47666",
  storageBucket: "steam-reviews-47666.appspot.com",
  messagingSenderId: "202787820220",
  appId: "1:202787820220:web:60840a072a5bebc88376b9",
  measurementId: "G-RD2TKS98QY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics, logEvent };
